/**
 * External Dependencies
 */

import Swiper from 'swiper/bundle';
// import './swiper-bundle.min.js';
import LazyLoad from "vanilla-lazyload";
import {
  gsap,
} from "gsap";
import smoothscroll from 'smoothscroll-polyfill';

document.addEventListener('DOMContentLoaded', function () {
  // smoothScroll init
  smoothscroll.polyfill();
  // smoothScroll init end

  // scroll header class
  function activeClassHeaderScroll() {
    const header = document.querySelector('.header');
    if (!header) return false;

    const headerHeight = header.offsetHeight + 15;

    window.addEventListener('scroll', function () {
      if (this.pageYOffset > headerHeight) {
        header.classList.add('active');
      } else {
        header.classList.remove('active');
      }
    })
  }

  activeClassHeaderScroll()
  // scroll header class end

  // dropdown

  function dropDown(eventClass) {
    const dropdown = document.querySelectorAll(`${'.' + eventClass}`)

    if (!dropdown) return false;

    dropdown.forEach(item => {
      item.addEventListener('click', () => {
        item.classList.toggle('active');

        const name = item.dataset.dropdownName;
        const elementBody = document.querySelector(`[data-dropdown="${name}"]`)

        if(!elementBody) return false;

        elementBody.classList.toggle('active');
      })
    })
  }

  dropDown('js-dropdown');

  // dropdown end

  // change theme
  let bodyTheme = document.querySelector('body[data-theme]');

  function setCookie(name, value, options = {}) {

    options = {
      path: '/',
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  function setCookieThemeName(name) {
    setCookie('themeName', name, {
      secure: true,
      'max-age': 3.154e+7,
    });
  }

  function changeTheme(btnClass) {
    const changeBtnTheme = document.querySelectorAll(`.${btnClass}`);
    let currentName = '';

    if (changeBtnTheme) {
      changeBtnTheme.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (bodyTheme.getAttribute('data-theme') === 'default') {
            currentName = 'dark';
          } else {
            currentName = 'default';
          }

          bodyTheme.setAttribute('data-theme', currentName);
          setCookieThemeName(currentName);
        })
      })
    }
  }

  changeTheme('js-change-theme');
  // change theme end
  // api

  let apiURL = 'https://api.addbot.tech/api/v1/currency/info';

  let xhrMatch = new XMLHttpRequest();
  xhrMatch.open('GET', apiURL, true);
  xhrMatch.send();

  xhrMatch.onreadystatechange = updateState;

  function updateState() {
    if (this.readyState != 4) return;
    if (this.status === 200) {
      let parseData = JSON.parse(this.responseText);
      // console.log(parseData);

      initFunctApi(parseData);

      setInterval((parseData)=>{
        initFunctApi(parseData);
      }, 5000)
    }
  }

  let coinsData = [];

  function coinsSetDataName(data){
      if(!data) return false;

      const currency = data.currency;

      Object.keys(currency).filter(coinName => {
        coinsData.push(coinName);
      })
  }

  // let coinsData = ['del', 'btt', 'dot', 'btt(minter)', 'wdx'];

  function coins(data) {
    let getCoins = document.querySelectorAll('.coins-item');

    if (getCoins) {
      getCoins.forEach((item) => {
        const coinName = item.getAttribute('data-coins-name');

        if (coinsData.length !== 0 && coinsData.indexOf(coinName) != -1) {
          let stakeTotal = item.querySelector('.js-stake-total');
          let rewardTotal = item.querySelector('.js-reward-total');
          let withDraw = item.querySelector('.js-with-draw');
          let perDay = item.querySelector('.js-per-day');

          setValItem(stakeTotal, `${'$' + data.currency[coinName].freeze.toFixed(3)}`);
          setValItem(rewardTotal, `${'$' + data.currency[coinName].reward.toFixed(3)}`);
          setValItem(withDraw, `${'$' + data.currency[coinName].withdraw_count.toFixed(3)}`);
          setValItem(perDay, data.currency[coinName].percent.toFixed(3));
        }
      })
    }
  }

  function setValItem(item, val) {
    if(!val || !item) return false;

    if (val && item) {
      item.innerHTML = val;
    } else {
      item.innerHTML = '-';
    }
  }

  function classItem(data, classElement) {
    let item = document.querySelector('.' + classElement);

    if (item) {
      setValItem(item, data);
    }
  }

  function initFunctApi(data) {
    if(!data) return false;

    classItem(data.user_count, 'js-user-count');
    classItem(data.user_count, 'js-worked-count');
    classItem(data.day_online, 'js-worked-day');
    classItem(Object.keys(data.currency).length, 'js-worked-coins');
    classItem(data.total_usd && data.total_usd.toFixed(2), 'js-worked-total');
    // setDate(data.update_time);
    coinsSetDataName(data);
    coins(data);
  }


  function setDate(data) {
    let GTMtime = Date.parse(`${data.substr(0, data.length - 1)}`);
    let newDate = new Date(GTMtime)
    var options = {
      date: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',

      },
      time: {
        timeZone: 'UTC',
        hour: 'numeric',
        minute: 'numeric',
      }

    };

    date = newDate.toLocaleString("ru", options.date).slice(0, -2)
    // time = newDate.toLocaleString("ru", options.time) + ' МСК'
    document.querySelector('#info-date').innerText = date;
    // document.querySelector('#info-time').innerText = time;
  }

  // api end

  let linkLoadHref = decodeURI(window.location.search);
  let regLinkLoadHref = /\utm_medium\=/;
  let linkUtm;
  let localStorgUtm;

  function DesctopModalView() {
    let modalApp = document.querySelectorAll('.js-download-app-link');

    linkUtm = linkLoadHref.slice(1);

    if (linkLoadHref.match(regLinkLoadHref)) {
      sessionStorage.setItem('utm', linkUtm);
    }

    localStorgUtm = sessionStorage.getItem('utm');

    linkUtm = `https://redirect.appmetrica.yandex.com/serve/1179620091235429134?click_id={transaction_id}&google_aid={GAID}&${localStorgUtm}`;

    modalApp.forEach(element => {
      if (localStorgUtm) {
        element.setAttribute('href', linkUtm);
      }
    });

    // if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   modalApp.forEach(element => {
    //     element.setAttribute('href', '#');
    //     element.removeAttribute('target');
    //
    //     // element.classList.add('modal-view');
    //     // element.setAttribute('data-modal', 'app-modal');
    //   });
    // } else {
    //
    // }
  }

  DesctopModalView();

  // home script

  let lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 300,
  });

  const swiper = new Swiper('.swiper-container', {
    speed: 400,
    spaceBetween: 0,
    effect: "fade",
    direction: 'vertical',
    mousewheel: {
      invert: false,
    },
    touchReleaseOnEdges: true,
  });

  const toSlideContent = document.querySelectorAll('.js-toslide-content');
  const toSlide = document.querySelectorAll('.js-toslide');

  function toSwiperSlide(data){
    if(!data) return false;

    data.forEach(el=>{
      el.addEventListener('click', (e)=>{
        e.preventDefault();
        const attrSlide = el.dataset.slide;

        swiper.slideTo(attrSlide, 300);


        // old version
        $('.js-pmenu').fadeOut(300);

        $('body').removeAttr('style');
        // old version end
      })
    })
  }

  if(toSlideContent){
    toSwiperSlide(toSlideContent);
  }

  if(toSlide){
    toSwiperSlide(toSlide);
  }


  swiper.on('slideChange', function (index) {
    var _slide = index.activeIndex + 1;
    var _total = swiper.slides.length;
    var _height = 100 / (_total - 1) * (_slide - 1);
    // console.log(_total);
    // console.log(_slide);
    // console.log(_height);
    $('.sb > span').css('height', _height + '%');

    if (_slide === 5 || _slide === 2 || _slide === 1) {
      $('.js-change-color').css('color', 'rgba(20, 16, 41, 0.8)');
      $('.sb svg path').css('fill', '#000');
      // $('.sb > span').css('background', '#000');
    } else {
      $('.js-change-color').css('color', '#fff');
      $('.sb svg path').css('fill', '#fff');
      // $('.sb > span').css('background', '#fff');
    }
  });

  const scene = document.querySelectorAll(".js-scene");

  scene.forEach(function (Item) {
    let parallaxInstance = new Parallax(Item);
  });

  // ключ к api
  // 7c428c8f68ba15ed8c3c1983bf22f5e90937995042ceb66fda9a9bc8df201a1f

  // gsap.quickSetter() mouse follower (GSAP 3)

  const fish = document.querySelectorAll(".js-rotate");
  // gsap.set(fish, { xPercent: -50, yPercent: -50, transformOrigin:'center' });

  const pos = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  };
  const mouse = {
    x: pos.x,
    y: pos.y,
  };
  const speed = 0.05;

  // const xSet = gsap.quickSetter(fish, "x", "px");
  // const ySet = gsap.quickSetter(fish, "y", "px");

  window.addEventListener("mousemove", e => {
    mouse.x = e.x;
    mouse.y = e.y;
  });

  let lastDx = 0,
      lastDy = 0;

  gsap.ticker.add(() => {
    const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

    pos.x += (mouse.x - pos.x) * dt;
    pos.y += (mouse.y - pos.y) * dt;
    // xSet(pos.x);
    // ySet(pos.y);

    const dx = mouse.x - pos.x;
    const dy = mouse.y - pos.y;

    const rotation = Math.atan2(dy, dx);
    let degree = (rotation * (180 / Math.PI) * -1);

    fish.forEach(function (Item) {
      gsap.set(Item, {
        rotation: degree,
        duration: 5,
      });
    });

  });
  // home script end

  // special thanks to Blake Bowen for most of the code.

  // dropdown

  const dropDowBtn = document.querySelectorAll('.js-dropdown-btn');

  function ShowDropDownChildMenu(btns) {
    btns.forEach(item => {
      item.addEventListener('click', function () {
        let parent = item.closest('.js-dropdown-item');
        let body = parent.querySelector('.js-dropdown-body');

        let child = item.closest('.js-dropdown-body');

        if (parent && !child) {
          parent.classList.toggle('active');
          body.classList.toggle('active');

          return false;
        }

        if (child) {
          parent.classList.add('active');

          return false;
        }
      })
    })
  }

  ShowDropDownChildMenu(dropDowBtn);

  // dropdown end

  // anchor scrollto

  const anchorLinks = document.querySelectorAll('.js-onclick');

  if (anchorLinks.length > 0) {
    anchorLinks.forEach(link => {
      link.onclick = function (e) {
        onScrollLinkClick(e)
      }
    })

    function onScrollLinkClick(e) {
      const anchor = e.target.closest('button');

      if (anchor && anchor.dataset.goto && document.querySelector(anchor.dataset.goto)) {
        const gotoBlock = document.querySelector(anchor.dataset.goto);
        const gotoBlockValue = gotoBlock.getBoundingClientRect().top + pageYOffset - document.querySelector('header').offsetHeight;

        window.scroll({
          top: gotoBlockValue,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }

  // anchor scrollto end

  let sections = document.querySelectorAll('.js-anchor-scroll');
  let anchor = document.querySelectorAll('.anchor');
  let header = document.querySelector('header');
  let header_height;

  if (header) {
    header_height = header.offsetHeight;
  }

  window.addEventListener('scroll', function () {
    let cur_pos = this.scrollY;

    sections.forEach((section) => {
      let top = section.offsetTop - header_height,
        bottom = top + section.offsetHeight;
      let currentAnchor;
      let currentId;

      if (cur_pos >= top && cur_pos <= bottom) {
        if (section.hasAttribute('id')) {
          currentId = section.getAttribute('id');

          currentAnchor = document.querySelector(`.anchor[data-goto="#${currentId}"]`);

          anchor.forEach(el => {
            el.classList.remove('active')
          })

          currentAnchor && currentAnchor.classList.add('active')
        }
      }
    });
  })

  // toggle

  const toggleNavBtns = document.querySelectorAll('.js-toggle[data-toggle-name]');
  const toggleContents = document.querySelectorAll('.js-toggle-content[data-toggle-content]');

  function toggleShow(btns) {
    btns.forEach(item => {
      item.addEventListener('click', function () {
        if (this.dataset.toggleName) {
          let toggleName = this.dataset.toggleName;
          let contentToggle = document.querySelector(`.js-toggle-content[data-toggle-content="${toggleName}"]`);

          toggleContents.forEach((contents) => {
            contents.classList.remove('active');
          })

          toggleNavBtns.forEach((btn) => {
            btn.classList.remove('active');
          })

          this.classList.add('active');
          contentToggle.classList.add('active');
        }
      })
    })
  }

  toggleShow(toggleNavBtns);
  // toggle end

  const selectorWrapper = document.querySelector('.select-wrapper');
  if (selectorWrapper) {
    selectorWrapper.addEventListener('click', function () {
      this.querySelector('.select').classList.toggle('open');
    })

    for (const option of document.querySelectorAll(".custom-option")) {
      option.addEventListener('click', function () {
        if (!this.classList.contains('selected')) {
          this.parentNode.querySelector('.custom-option.selected').classList.remove('selected');

          this.classList.add('selected');

          if (this.closest('.select--user-guids')) {
            this.closest('.select').querySelector('.select__trigger-select').textContent = this.textContent;
          } else {
            this.closest('.select').querySelector('.select__trigger-select').innerHTML = this.querySelector('.coins-nav-item').outerHTML;
          }
        }
      })
    }

    window.addEventListener('click', function (e) {
      const select = document.querySelector('.select')
      if (!select.contains(e.target)) {
        select.classList.remove('open');
      }
    });
  }

  // mobile menu

  function mobileMenu(btn) {
    const button = document.querySelector(`.${btn}`);
    const menu = document.querySelector('.js-mobile-menu');
    const body = document.querySelector('body');
    const activeClass = 'active';

    if (!button) return false;

    button.addEventListener('click', () => {
      menu.classList.toggle(activeClass);
      if (menu.classList.contains(activeClass)) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'unset';
      }
    })
  }

  mobileMenu('js-mobile-btn');

  // mobile menu end


  // active class

  const navItems = document.querySelectorAll('.js-active-class');

  function activeClassToLoadedPage(items){
    if(!items) return false;

    items.forEach(item=>{
      const slug = item && item.getAttribute('id');

      if(document.location && document.location.pathname.indexOf(slug) !== -1){
        item.classList.add('active');
      }
    })
  }

  activeClassToLoadedPage(navItems);

  // active class end
});

$(document).ready(function () {
  "use strict";

  // let swiperJq = new Swiper();

  let $one = $('.js-shadow-1'),
      $two = $('.js-shadow-2'),
      browserPrefix = "",
      usrAg = navigator.userAgent;
      if (usrAg.indexOf("Chrome") > -1 || usrAg.indexOf("Safari") > -1) {
        browserPrefix = "-webkit-";
      } else if (usrAg.indexOf("Opera") > -1) {
        browserPrefix = "-o";
      } else if (usrAg.indexOf("Firefox") > -1) {
        browserPrefix = "-moz-";
      } else if (usrAg.indexOf("MSIE") > -1) {
        browserPrefix = "-ms-";
      }

  $(document).mousemove(function (event) {
    var cx = Math.ceil(window.innerWidth / 2.0),
      cy = Math.ceil(window.innerHeight / 2.0),
      dx = event.pageX - cx,
      dy = event.pageY - cy,
      tiltx = (dy / cy),
      tilty = -(dx / cx),
      radius = Math.sqrt(Math.pow(tiltx, 2) + Math.pow(tilty, 2)),
      degree = (radius * 15);

    var shadx = degree * tiltx; /*horizontal shadow*/
    var shady = degree * tilty; /*vertical shadow*/

    // $one.css(browserPrefix + 'transform', 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)');
    // $two.css(browserPrefix + 'transform', 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)');

    if (dx > cx) {
      /*without that horizontal values are reversed*/
      // $('#div1, #div2').css('box-shadow', + (-shady) + 'px ' + (-shadx) +'px 5px #3D352A');
      $('.js-shadow-1').css('box-shadow', +shady + 'px ' + shadx + 'px 96px 0 rgba(9, 13, 20, 0.4), ' + (-shady / 2) + 'px ' + (-shadx / 2) + 'px 32px 0 rgba(224, 224, 255, 0.04), -2px 16px 16px 0 rgba(9, 13, 20, 0.4)');
      $('.js-shadow-2').css('box-shadow', +shady + 'px ' + shadx + 'px 96px 0 rgba(9, 13, 20, 0.06), ' + (-shady / 2) + 'px ' + (-shadx / 2) + 'px 32px 0 rgba(255, 255, 255, 0.4), 0 16px 16px 0 rgba(9, 13, 20, 0.06)');
    } else {
      $('.js-shadow-1').css('box-shadow', +shady * 2 + 'px ' + shadx * 2 + 'px 96px 0 rgba(9, 13, 20, 0.4), ' + (-shady / 2) + 'px ' + (-shadx / 2) + 'px 32px 0 rgba(224, 224, 255, 0.04), -2px 16px 16px 0 rgba(9, 13, 20, 0.4)');
      $('.js-shadow-2').css('box-shadow', +shady * 2 + 'px ' + shadx * 2 + 'px 96px 0 rgba(9, 13, 20, 0.06), ' + (-shady / 2) + 'px ' + (-shadx / 2) + 'px 32px 0 rgba(255, 255, 255, 0.4), 0 16px 16px 0 rgba(9, 13, 20, 0.06)');

    }
  });

  $('.js-openmenu').click(function (e) {
    e.preventDefault();
    $('.js-pmenu').fadeIn(300).css('display', 'flex');
    $('body').css('overflow', 'hidden');
  });

  $('.js-closemenu').click(function (e) {
    e.preventDefault();
    $('.js-pmenu').fadeOut(300);
    $('body').removeAttr('style');
  });

  // filter start

  $('.js-filter-btn').on('click', function () {
    $('.js-filter-btn').removeClass('active');
    $(this).addClass('active');

    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html',
      data: {
        action: 'filter_projects',
        category: $(this).data('slug'),
        type: $(this).data('type'),
      },
      beforeSend: function () {
        console.log('SEND');
      },
      complete: function () {
        console.log('Complete');
      },
      success: function (res) {
        let data = JSON.parse(res);

        if (!$.isEmptyObject(data)) {
          if (data.type === 'post') {
            $('.js-article-list').html(data.posts);
          } else {
            $('.js-article-list').html(data.posts);
          }
        }

        if (!$.isEmptyObject(data.titles)) {
          let lists = [];

          data.titles.forEach((el, index) => {
            lists.push(`
                <button type="button" data-goto="#${el.slug}" class="anchor user-guids__pages-item">
                    <span class="user-guids__pages-item-text">${index + 1 + '. ' + el.title}</span>
                </button>
            `);
          })

          $('.js-article-list-title').html(lists);
        }
      },
    })
  });

  // filter end

  // loadmore start

  $(function ($) {
    let canBeLoaded = true,
      bottomOffset = 2000;

    $(window).scroll(function () {
      let data = {
        'action': 'loadmore',
        'query': load_more_params.posts,
        'page': load_more_params.current_page,
      };

      // console.log(load_more_params.posts);

      if ($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded == true && +load_more_params.isPageLoad) {
        $.ajax({
          url: load_more_params.ajaxurl,
          data: data,
          type: 'POST',
          beforeSend: function (xhr) {
            canBeLoaded = false;
          },
          success: function (data) {
            if (data) {

              $('.js-article-list').find('.article-block:last-of-type').after(data); // where to insert posts
              canBeLoaded = true;
              load_more_params.current_page++;
            }
          },
        });
      }
    });
  });

  // loadmore end

});
